import React from 'react';
import Image from 'next/image';
import { Box } from '@mui/material';
import PrimaryActionTitleBodySection from './PrimaryActionTitleBodySection';

const PrimaryActionHeaderSection = ({
  actionImage,
  actionTitle,
  actionBody,
  theme,
  layoutOption,
}) => (
  <Box
    sx={{
      width: '100%',
      height: 'auto',
      position: 'relative',
      paddingBottom: '1rem',
    }}
  >
    <Box
      sx={{
        display: 'flex',
        flexDirection: {
          xs: 'column',
          sm: 'column',
          md: layoutOption === 'left' ? 'row' : 'row-reverse',
        },
        alignItems: 'center',
        gap: '24px',
        width: '100%',
        height: '100%',
        maxHeight: 'auto',
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: { sm: '540px', md: '768px', lg: '1180px', xl: '1180px' },
        position: 'relative',
      }}
    >
      <Box
        component="div"
        id="action-image-div"
        sx={{
          overflow: 'hidden',
          marginRight: layoutOption === 'right' ? '16px' : '0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          width: '95%',
          minWidth: { xs: '330px', sm: '500px', md: '375px' },
          height: '100%',
          maxHeight: 'auto',
        }}
      >
        {actionImage && (
          <Image
            src={actionImage}
            alt={actionTitle}
            height={360}
            width={580}
            style={{
              borderRadius: '20px',
              objectFit: 'cover',
            }}
          />
        )}
      </Box>
      <Box
        component="div"
        id="action-body-div"
        sx={{
          paddingLeft: { xs: '0px', md: '10px', lg: '72px' },
          position: 'relative',
          width: '100%',
          maxWidth: {
            xs: '375px',
            sm: '540px',
            md: '768px',
            lg: '1180px',
            xl: '1180px',
          },
        }}
      >
        <PrimaryActionTitleBodySection
          actionTitle={actionTitle}
          actionBody={actionBody}
          theme={theme}
        />
      </Box>
    </Box>
  </Box>
);

export default PrimaryActionHeaderSection;
